<!-- confirmation-dialog.html -->

<div class="w-[32rem]">

  <!-- Header -->
  <div
    class="flex items-center justify-between border-b border-b-primary-10 w-full p-4"
  >
    <span class="text-xl font-bold">
      {{ data.title }}
    </span>

    <mat-icon
      class="h-5 w-5 text-xl leading-5 cursor-pointer"
      (click)="onClose()"
    >
      close
    </mat-icon>
  </div>

  <!-- Body -->
  <div class="p-4 border-b border-b-primary-10">

    <p [innerHTML]="data.message"></p>

    @if (data.subText) {
      <p
        class="mt-2"
        [class.font-bold]="data.extra?.isBoldSubText"
        [innerHTML]="data.subText"
      ></p>
    }

    @if (data.extra?.type === 'input') {

      <div class="mt-2">

        <input
          #confirmedInput
          type="text"
          class="w-full border border-primary-75 px-2 py-1 rounded"
          [placeholder]="'Type &quot;' + confirmText() + '&quot;'"
          (keyup)="validateTypedText(confirmedInput.value)"
          noCopyPaste
        />

      </div>
    }

  </div>

  <!-- Footer -->
  <div class="flex justify-end py-2 px-6">

    @if (data.secondaryButton) {

      <div class="ml-4">
        <isc-button
          type="outlined"
          [label]="data.secondaryButton"
          (onClick)="onSecondaryClick()"
        />
      </div>

    }

    @if (data.primaryButton) {

      <div class="ml-4">
        <isc-button
          type="filled"
          [label]="data.primaryButton"
          [disabled]="disableButton()"
          (onClick)="onPrimaryClick()"
        />
      </div>

    }

  </div>

</div>